
define(
  'CCTSlide.EntryPoint',
  [
    'CCTSlider.View'
  ], function (
    SliderView
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        container.getComponent('CMS').registerCustomContentType({
          id: 'customrecord_cct_slider',
          view: SliderView
        });
      }
    };
  });
